import type { CustomIconProps } from '../CustomIcon';

export const CertificationIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  size = 24,
  solid,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M0 0h24v24H0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 2a4 4 0 0 1 4 4c0 1.32-.418 2.36-.813 3.344-.353.879-.687 1.712-.687 2.656 0 1.545 1.277 1.963 2 2H20a2 2 0 0 1 2 2v2H2v-2a2 2 0 0 1 2-2h3.5c.723-.037 2-.455 2-2 0-.944-.334-1.777-.687-2.656C8.418 8.36 8 7.32 8 6a4 4 0 0 1 4-4Z'
      fill={color}
    />
    <path
      d='m15.187 9.344.696.28-.696-.28ZM16.5 14l-.038.749.038.001V14Zm5.5 4v.75a.75.75 0 0 0 .75-.75H22ZM2 18h-.75c0 .414.336.75.75.75V18Zm5.5-4v.75l.038-.001L7.5 14Zm1.313-4.656-.696.28.696-.28ZM16.75 6A4.75 4.75 0 0 0 12 1.25v1.5A3.25 3.25 0 0 1 15.25 6h1.5Zm-.867 3.623c.393-.977.867-2.141.867-3.623h-1.5c0 1.158-.361 2.075-.759 3.064l1.392.56ZM15.25 12c0-.776.272-1.476.633-2.377l-1.392-.559c-.344.858-.741 1.824-.741 2.936h1.5Zm1.288 1.251c-.262-.013-.606-.099-.864-.289-.221-.163-.424-.432-.424-.962h-1.5c0 1.015.436 1.728 1.034 2.169.561.415 1.217.557 1.678.58l.076-1.498ZM16.5 14.75H20v-1.5h-3.5v1.5Zm3.5 0c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0 0 20 13.25v1.5ZM21.25 16v2h1.5v-2h-1.5Zm.75 1.25H2v1.5h20v-1.5ZM2.75 18v-2h-1.5v2h1.5Zm0-2c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 1.25 16h1.5ZM4 14.75h3.5v-1.5H4v1.5ZM8.75 12c0 .53-.203.799-.424.962-.258.19-.601.276-.864.289l.076 1.498c.46-.023 1.117-.165 1.679-.58.597-.441 1.033-1.154 1.033-2.169h-1.5Zm-.633-2.377c.361.9.633 1.6.633 2.377h1.5c0-1.112-.397-2.078-.741-2.936l-1.392.56ZM7.25 6c0 1.482.474 2.646.867 3.623l1.392-.559C9.112 8.075 8.75 7.158 8.75 6h-1.5ZM12 1.25A4.75 4.75 0 0 0 7.25 6h1.5A3.25 3.25 0 0 1 12 2.75v-1.5Z'
      fill={color}
    />
    <path fill={secondaryColor} d='M4 20h16v2H4z' />
  </svg>
);
